import React from "react";
import styled from "styled-components";
import menuUrl from "../assets/images/menu.svg";

export const Box = styled.div`
  position: relative;
  background: #f8f8f8;
  padding: 30px 50px 30px 24px;
  margin-bottom: 20px;

  h1 {
    margin-bottom: 1.3em;
    font-size: 24px;
    color: #284d71;
  }
  
  p {
    line-height: 26px;
    position: relative;
    font-weight: 400;
  }
  
  .box-description {
    font-size:20px;
  }
  
  @media print {
    display: none;
  }
`;


export default Box;
